export const TEILNEHMERKENNUNG_GENERISCH = "generisch";

export const enum eGENA_TeilnehmerStatus {
	UNGÜLTIG = 			'ungueltig',
	GÜLTIG =			'gueltig',
	UNVERÖFFENTLICHT =	'unveroeffentlicht',
	VERÖFFENTLICHT =	'veroeffentlicht'
	}

export class eGENA_TeilnehmerInfo {
	public Status : eGENA_TeilnehmerStatus;
	public TeilnehmerBezeichnung : string;
	public Zusatzinformationen : string | undefined;

	public constructor(Status : eGENA_TeilnehmerStatus, TeilnehmerBezeichnung : string, Zusatzinformationen : string | undefined) {
		this.Status = Status;
		this.TeilnehmerBezeichnung = TeilnehmerBezeichnung;
		this.Zusatzinformationen = Zusatzinformationen;
	}

	public static getInstanceForInvalid() : eGENA_TeilnehmerInfo {
		return new eGENA_TeilnehmerInfo(eGENA_TeilnehmerStatus.UNGÜLTIG, "", undefined);
	}

	public static getInstanceForTeilnehmerkennung(teilnehmerkennung : string | undefined) : eGENA_TeilnehmerInfo {
		if (!teilnehmerkennung)
			return this.getInstanceForInvalid();
		if (teilnehmerkennung !== TEILNEHMERKENNUNG_GENERISCH) {
			if (teilnehmerkennung.length != 8) {
				return new eGENA_TeilnehmerInfo(eGENA_TeilnehmerStatus.UNGÜLTIG, "", "Das Format der Teilnehmerkennung ist ungültig. Die Teilnehmerkennung besteht aus genau 8 Ziffern");
			}
			if (! /\d/.test(teilnehmerkennung)) {
				return new eGENA_TeilnehmerInfo(eGENA_TeilnehmerStatus.UNGÜLTIG, "", "Das Format der Teilnehmerkennung ist ungültig. Die Teilnehmerkennung besteht ausschließlich aus Ziffern");
			}
		}

		return new eGENA_TeilnehmerInfo(eGENA_TeilnehmerStatus.GÜLTIG, "", undefined);
	}

	public static fromJSONstring(json : string) : eGENA_TeilnehmerInfo {
		let object : any;
		try {
			object = JSON.parse(json);
		} catch (e) {
			throw new Error("Der JSON-String ist nicht im erwarteten Format. JSON-String: " + json);
		}

		if (!('Status' in object))
			throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'Status' ist nicht definiert. JSON-String: " + json);

		let TeilnehmerBezeichnung : string;
		if (!('TeilnehmerBezeichnung' in object))
			TeilnehmerBezeichnung = "";
		else
			TeilnehmerBezeichnung = object.TeilnehmerBezeichnung;

		return new eGENA_TeilnehmerInfo(object.Status, TeilnehmerBezeichnung, undefined);
	}
}


// WEBPACK FOOTER //
// ./src/visionet/TeilnehmerInfo.ts